import { initStackedSlider, setupStackedSliderHeight } from './stacked-slider';

const initNieruchomoscSlider = ( slider ) => {
    if ( ! slider || slider.dataset.nhSliderInitialized === '1' ) {
        return;
    }

    slider.dataset.nhSliderInitialized = '1';
    slider.classList.add( 'nh-slider--enhanced' );

    const heightManager = setupStackedSliderHeight( slider, {
        wrapperSelector: '.nh-slides',
        slideSelector: '.nh-slide',
    } );

    initStackedSlider( slider, {
        slideSelector: '.nh-slide',
        dotsContainerSelector: '.nh-dots',
        prevArrowSelector: '.nh-nav__button--prev',
        nextArrowSelector: '.nh-nav__button--next',
        dotAriaLabel: ( index ) => `Oferta ${ index + 1 }`,
        onSlideChange: ( detail ) => {
            if ( heightManager ) {
                heightManager.observe( detail.currentSlide );
                heightManager.schedule();
            }
        },
    } );

    if ( heightManager ) {
        const initialSlide = slider.querySelector( '.nh-slide' );
        heightManager.observe( initialSlide );
        heightManager.schedule();
    }
};

export default initNieruchomoscSlider;
